import React from 'react'
import { Route, Routes } from 'react-router-dom'
import Login from '../pages/Auth/Login'
import Dashboard from '../pages/Dashboard/Dashboard'
import Profile from '../common/Profile'
import CheckAuth from './CheckAuth'
import Mmv from '../pages/MMV/Mmv'
import ForgotPassword from '../pages/Auth/ForgotPassword'
import CreatePassword from '../pages/Auth/CreatePassword'
import Users from '../pages/Users/users'
import AddUser from '../pages/Users/AddUser'
import Rto from '../pages/RTO/Rto'
import Sidebar from '../common/Sidebar'
import QuoteError from '../pages/ErrorHandling/QuoteError'
import TpError from '../pages/ErrorHandling/TpError'
import AddMmv from '../pages/MMV/AddMmv'
import AddMM from '../pages/AddMappingManager/AddMM'
import AddRto from '../pages/RTO/AddRto'
import AddPincod from '../pages/AddPincode/AddPincod'
import ProposalError from '../pages/ErrorHandling/ProposalError'
import MmvMaster from '../pages/AddMaster/MmvMaster'
import PrevInsurer from '../pages/PrevInsurer/PrevInsurer'
import AddPrevInsurer from '../pages/AddPrevInsurer/AddPrevInsurer'
import Occupation from '../pages/Occupation/Occupation'
import MapOccupation from '../pages/Occupation/MapOccupation'
import Financer from '../pages/Financer/Financer'
import Relation from '../pages/Relation/Relation'
import AddRelation from '../pages/Relation/AddRelation'
import ExportMaster from '../pages/ExportMaster/ExportMaster'
import ExportInsurerMaster from '../pages/ExportMaster/ExportInsurerMaster'
import UploadDocument from '../pages/UploadDocument'
import InsurerDocuments from '../pages/InsurerDocuments'


const AllRoutes = () => {
  return (
    <> 
  
     
    <Routes>
    <Route path='/' element={<Login />} />{' '}
     
      <Route path='/forget' element={<ForgotPassword />} />{' '}
      <Route path='/create' element={<CreatePassword />} />{' '}
      <Route element={<CheckAuth />}>
        <Route path='/dashboard' element={<Dashboard />} />
        
        {/* Mapping*/}
        <Route path='/mmv' element={<Mmv />} />
        <Route path='/rto' element={<Rto />} />
        <Route path='/users' element={<Users />} />
        <Route path='/add-user' element={<AddUser />} />
        <Route path='/quoteError' element={<QuoteError />} />
        <Route path='/tpError' element={<TpError />} />
        <Route path='/addMmv' element={<AddMmv />} />
        <Route path='/addMM' element={<AddMM />} />
        <Route path='/add-rto' element={<AddRto />} />
        <Route path='/add-pincode' element={<AddPincod />} />

        <Route path='/proposalError' element={<ProposalError />} />
        <Route path='/add-master' element={<MmvMaster />} />
        <Route path='/prev-insurer' element={<PrevInsurer />} />
        <Route path='/add-prev-insurer' element={<AddPrevInsurer />} />
        <Route path='/add-occupation' element={<Occupation />} />
        <Route path='/occupation' element={<MapOccupation />} />
        <Route path='/financer' element={<Financer />} />
        <Route path='/relation' element={<Relation />} />
        <Route path='/add-relation' element={<AddRelation />} />
        <Route path='/export-master' element={<ExportMaster/>} />
        <Route path='/export-insurer-master' element={<ExportInsurerMaster/>} />
        <Route path='/upload-document' element={<UploadDocument/>} />
        <Route path='/insurer-document' element={<InsurerDocuments/>} />



        {/* Profile */}
        <Route path='/profile' element={<Profile />} />
      </Route>
    </Routes>
    </>
 
  )
}

export default AllRoutes
